module.exports = __webpack_public_path__ + "static/media/CTLI_15-315w.d6e1081f.webp";